<div class="p-b-24" [ngClass]="{'d-none': hideBreadcrumb}">
  <div>
    <div class="row">
      <div class="w-50 align-content-center">
        <h2 class="page-title m-0 f-s-18 f-w-500 title">
          {{ pageInfo?.['title']}}
        </h2>
        <div
          class="breadcrumb-display d-flex align-items-center overflow-hidden justify-content-start list-style-none m-t-8">
          @for (url of pageInfo?.['urls']; track url; let last = $last) {
          @if (!last) {
          <li class="breadcrumb-item" [routerLink]="url.url">
            <a [routerLink]="url.url" class="text-primary" [ngClass]="{ 'no-link': !url.url }">{{
              url.title }}</a>
          </li>
          }
          @if (last) {
          <li class="breadcrumb-item active">{{ url.title }}</li>
          }
          }
        </div>
      </div>
      <div class="filter-bar text-right d-flex justify-content-end align-items-center gap-20">
        @if (filters.length) {
        <!-- Filter icon -->
        <app-filter-bar [filtersList]="filters" [fromBreadcrumb]="true" [showButton]="true" class="col-10" />
        }
      </div>

      @if (filters.length) {
      <div class="col-12" style="padding: 0;">
        <app-filter-bar class="w-100" [filtersList]="filters" [filtersOptions]="filtersOptions" [fromBreadcrumb]="true"
          [showButton]="false" />
      </div>
      }
    </div>
  </div>
</div>